<div class="table-view-container">
  <div class="table-responsive">
    <table class="table table-hover table-striped articles-table">
      <thead class="thead-light sticky-top">
        <tr>
          <th style="width: 80px">{{"IMAGE" | translate}}</th>
          <th>{{"DESCRIPTION" | translate}}</th>
          <th style="min-width: 148px; max-width: 180px;">{{"ARTICLE_NO" | translate}}</th>
          <th style="width: 120px">{{"BRAND" | translate}}</th>
          <th style="width: 100px" class="text-end">{{"PRICE" | translate}}</th>
          <th style="width: 150px">{{"STOCK" | translate}}</th>
          <th style="width: 120px" class="text-center">{{"ACTIONS" | translate}}</th>
        </tr>
      </thead>
      <tbody>
        @for (article of articles; track trackByArticleId($index, article)) {
          <tr
            class="article-row clickable"
            [class.active-row]="activeArticle === article"
            (click)="viewArticleDetails(article)"
            >
            <!-- Image -->
            <td class="align-middle">
              <div class="article-thumbnail">
                <ng-template #imgPopover>
                  <img
                    [src]="getArticleImage(article)"
                    [alt]="article.description"
                    class="thumbnail-enlarged"
                  />
                </ng-template>
                <img
                  [src]="getArticleImage(article)"
                  [alt]="article.description"
                  class="img-thumbnail"
                  loading="lazy"
                  [ngbPopover]="imgPopover"
                  triggers="mouseenter:mouseleave"
                  placement="right"
                  container="body"
                  />
              </div>
            </td>
            <!-- Description -->
            <td class="align-middle">
              <div class="article-description">
                {{ article.description }}
              </div>
              @if (article.caption) {
                <div class="text-muted small">
                  {{ article.caption }}
                </div>
              }
              <!-- Badges -->
              <div class="mt-1">
                @if (article.new) {
                  <span class="badge bg-success me-1">
                    {{"NEW" | translate}}
                  </span>
                }
                @if (article.base_collection) {
                  <span class="badge bg-info me-1">
                    {{"BASE_COLLECTION" | translate}}
                  </span>
                }
              </div>
            </td>
               <!-- Article Code -->
            <td class="align-middle">
              <strong>{{ article.single_article_code || article.article_codes.join(', ') }}</strong>
              @if (article.ean) {
                <div class="text-muted small">
                  EAN: {{ article.ean }}
                </div>
              }
            </td>
            <!-- Brand -->
            <td class="align-middle">
              {{ article.brand || '-' }}
            </td>
            <!-- Price -->
            <td class="align-middle text-end">
              @if (!article.hide_nett_price) {
                <div>
                  <app-nett-price
                    [price]="article.net_price"
                    [hasDifferentPrices]="article.has_different_prices"
                    [showLabel]="false"
                    [volumePrices]="article.volume_price"
                    [article]="article"
                    >
                  </app-nett-price>
                  <app-gross-price
                    [price]="article.gross_price"
                    [showLabel]="true"
                  ></app-gross-price>
                </div>
              }
              @if (article.retail_price?.value) {
                <div class="text-muted small">
                  <app-retail-price
                    [price]="article.retail_price"
                    [showLabel]="false"
                  ></app-retail-price>
                </div>
              }
            </td>
            <!-- Availability -->
            <td class="align-middle">
              @if (!article.matrix || article.matrix.options.length <= 1) {
                <app-stock-status
                  [showText]="true"
                  class="w-100 d-block pt-1"
                  (click)="gotoItem($event, article)"
                  [article]="article"
                ></app-stock-status>
              }
            </td>
            <!-- Actions -->
            <td class="align-middle text-center" (click)="$event.stopPropagation()">
              <div class="btn-group btn-group-sm gap-1" role="group">
                <!-- Favorite -->
                <button
                  type="button"
                  class="btn btn-outline-secondary"
                  [ngClass]="{'text-danger': isFavorite(article)}"
                  (click)="toggleFavorite(article, $event)"
                  [title]="(isFavorite(article) ? 'REMOVE_FROM_FAVORITES' : 'ADD_TO_FAVORITES') | translate"
                  >
                  <i class="material-icons" style="font-size: 18px">
                    {{ isFavorite(article) ? 'favorite' : 'favorite_border' }}
                  </i>
                </button>
                <!-- Add to Basket -->
                <button
                  type="button"
                  class="btn btn-outline-primary"
                  (click)="onAddToBasket(article, $event)"
                  [disabled]="!article.authorized_to_place_in_basket"
                  [title]="'ADD_TO_BASKET' | translate"
                  >
                  <i class="material-icons" style="font-size: 18px">
                    shopping_cart
                  </i>
                </button>
                <!-- View Details -->
                <button
                  type="button"
                  class="btn btn-outline-secondary"
                  (click)="viewArticleDetails(article)"
                  [title]="'VIEW_DETAILS' | translate"
                  >
                  <i class="material-icons" style="font-size: 18px">
                    visibility
                  </i>
                </button>
              </div>
            </td>
          </tr>
        }
      </tbody>
    </table>

    <!-- Empty State -->
    @if (!articles || articles.length === 0) {
      <div class="text-center py-5">
        <i class="material-icons text-muted" style="font-size: 48px">
          search_off
        </i>
        <p class="text-muted mt-3">{{ "NO_ARTICLES_FOUND" | translate }}</p>
      </div>
    }
  </div>
</div>
